import { gql } from '../../../apollo/__generated__';

export const ADD_ROLE = gql(`
  mutation AddRole($addRoleInput: AddRoleInput!) {
    addRole(addRoleInput: $addRoleInput) {
      id
      roles {
        name
        givenByUser {
          id
          firstname
          lastname
          email
        }
      }
    }
  }
`);
